import { render, staticRenderFns } from "./SearchPopup.vue?vue&type=template&id=8a159faa&scoped=true"
import script from "./SearchPopup.vue?vue&type=script&lang=ts"
export * from "./SearchPopup.vue?vue&type=script&lang=ts"
import style0 from "./SearchPopup.vue?vue&type=style&index=0&id=8a159faa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a159faa",
  null
  
)

export default component.exports